/**
 * The service for interacting with local storage
 * Includes pub-sub functions for syncing data across the app
 * @param {} constants 
 * @returns {} 
 */
export default function ($rootScope, timetableConfig, timetableService) {

    var selectedTerm = {},
        recent = [],
        planner = [];

    /**
     * Update the added to planner list when selected term updates
     */
    timetableService.subscribe($rootScope.$new(), 'selectedTermChanged',
        function selectedTermChanged(e, arg) {
            selectedTerm = arg;
        });

    /**
     * Push the planner courses into local storage, if available, using the selected term id as an identifier for later retrieval
     * @param {} data 
     * @param {} term 
     * @returns {} 
     */
    function storePlanner(data) {
        if (timetableConfig.HAS_LOCALSTORAGE && data !== null && selectedTerm && selectedTerm.id) {
            localStorage[timetableConfig.LOCAL_STORE_KEY + 'planner_' + selectedTerm.id] = JSON.stringify(data);
        }
    }

    /**
     * Push recently viewed courses object into local storage, if it is available
     * @param {} data 
     * @returns {} 
     */
    function storeRecent(data) {
        if (timetableConfig.HAS_LOCALSTORAGE && data !== null) {
            localStorage[timetableConfig.LOCAL_STORE_KEY + 'recent'] = JSON.stringify(data);
        }
    }

    /**
     * Retrieves recent course search information from localstorage. If none exists, or localstorage is not available, returns an empty array
     * @returns {} 
     */
    function getRecent() {
        if (timetableConfig.HAS_LOCALSTORAGE) {
            recent = JSON.parse(localStorage.getItem(timetableConfig.LOCAL_STORE_KEY + 'recent')) || [];
            $rootScope.$emit('getRecent', recent);
            return recent;
        }
        return [];
    }

    /**
     * Retrieves planner information from localstorage, provided a term has been selected. If none exists, or localstorage is not available, returns an empty array 
     * @returns {} 
     */
    function getPlanner() {
        if (timetableConfig.HAS_LOCALSTORAGE && selectedTerm && selectedTerm.id) {
            planner = JSON.parse(localStorage.getItem(timetableConfig.LOCAL_STORE_KEY + 'planner_' + selectedTerm.id)) || [];
            $rootScope.$emit('getPlanner', planner);
            return planner;
        }
        return [];
    }

    return {
        storePlanner: storePlanner,
        storeRecent: storeRecent,
        getPlanner: getPlanner,
        getRecent: getRecent
    }
};